@if (isBigButton()) {
    <button
        class="box-border flex h-52 w-full items-center gap-8 border-2 border-accent px-20 py-10 font-headline text-16 leading-20 text-accent"
        (click)="onClick()"
    >
        <!-- Icon used directly because icon-font is not rendering it correctly -->
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M19.25 2.75V20.7256L12.3643 16.9004L12 16.6973L11.6357 16.9004L4.75 20.7256V2.75H19.25Z"
                stroke="#002C5F"
                stroke-width="1.5"
            />
        </svg>
        Suche speichern
    </button>
} @else {
    <button
        ui-m010-c020-icon-link
        class="flex gap-8 font-headline text-16 leading-20 text-accent"
        [reversedOrder]="true"
        [inverted]="theme() === 'dark'"
        (click)="onClick()"
    >
        Suche speichern
    </button>
}
